module.exports = __webpack_public_path__ + "static/media/eraser.77bfe8f9.svg";